
































import Vue from 'vue'
export default Vue.extend ({
    props: {
        //  The name of the vuex getter that holds progress data
        bind: {
            type: String,
            required: true
        },
        //  The color of the circular spinner
        color: {
            type: String,
            default: 'primary'
        },
        //  The icon displayed above the spinner
        iconTop: {
            type: String,
            default: null
        },
        //  The icon displayed below the spinner
        iconBottom: {
            type: String,
            default: null
        },
        //  The image displayed above the progress circular (overrides iconTop)
        imgTop: {
            type: String,
            default: null
        },
        //  Style applied to the top image
        imgTopStyle: {
            type: String,
            default: null
        },
        //  The width of the image displayed above the progress circular
        imgTopWidth: {
            type: String,
            default: '230px'
        },
        //  The image displayed below the progress circular (overrides iconBottom)
        imgBottom: {
            type: String,
            default: null
        },
        //  Style applied to the bottom image
        imgBottomStyle: {
            type: String,
            default: null
        },
        //  The width of the image displayed below the progress circular
        imgBottomWidth: {
            type: String,
            default: '160px'
        }
    },
    computed: {
        progress(): object {
            return this.$store.getters[this.bind]
        }
    }
})
